<template>
	<div class="tag">
		<div class="tag-closer"></div>
	</div>
</template>

<script>
export default {
	name: "Annotation",
	props: ["annotation"],
	data() {
		return {
			mut_annotation: _.clone(annotation)
		};
	},

	watch: {},

	created() {},

	mounted() {
		var el = this.$refs.tag;
		$(el).css({
			width: this.mut_annotation.width + "%",
			height: this.mut_annotation.height + "%",
			top: this.mut_annotation.top + "%",
			left: this.mut_annotation.left + "%"
		});
	},

	methods: {}
};
</script>

<style scoped>
.tag {
	background-color: #ffff91;
	min-width: 10px;
	min-height: 10px;
	position: absolute;
	top: 0;
	left: 0;
	opacity: 0.5;
	-webkit-box-shadow: 2px 2px 0px 0px rgba(231, 237, 197, 0.41);
	-moz-box-shadow: 2px 2px 0px 0px rgba(231, 237, 197, 0.41);
	box-shadow: 2px 2px 0px 0px rgba(231, 237, 197, 0.41);
}

.tag-closer {
	position: absolute;
	display: none;
	top: -8px;
	right: -8px;
	height: 16px;
	width: 16px;
	/* content: "X"; */
	border-radius: 8px;
	background-color: purple;
	font-size: 8px;
	/* opacity: 0.8; */
	border: 1px;
	color: black;
}

.tag:hover .tag-closer {
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/viewer/Annotation.vue